import React from 'react';
import Button from 'react-bootstrap/Button';
import { ImageModel, LinkModel } from '../../models/globals';
import { ReadMoreHtml } from '../common/ReadMoreHtml';
import { BackgroundPicture } from '../html5/BackgroundPicture';

interface CategoryBannerProps {
    defaultImage: ImageModel;
    description: string | null;
    truncatedDescription: string | null;
    image: ImageModel;
    name: string;
    searchLink: LinkModel;
}

const CategoryBanner: React.FC<CategoryBannerProps> = ({
    defaultImage,
    description,
    truncatedDescription,
    image,
    name,
    searchLink,
}) => {
    return (
        <BackgroundPicture
            {...image}
            defaultImage={defaultImage}
            omitAlt // The text overlay (name) makes the alt redundant
        >
            <div className="page-banner-content col-md-6 mx-auto my-4 p-5 px-md-2 text-center text-shadow text-white">
                <h1 className="page-banner-name font-weight-light mb-4">{name}</h1>
                <ReadMoreHtml
                    btnClassName="text-capitalize text-shadow text-white"
                    className="page-banner-description font-weight-light h4 mb-5"
                    fullHtml={description ?? ''}
                    truncatedHtml={truncatedDescription}
                    ariaLabelSuffix={'about ' + name}
                />
                <Button className="px-4 py-2 text-shadow-none" href={searchLink.url} variant="primary">
                    {searchLink.name}
                </Button>
            </div>
        </BackgroundPicture>
    );
};

export { CategoryBanner, CategoryBannerProps };
